import {InputSProps} from "@FRAMEWORK/ui/types/d";
import {ReactNode} from "react";
import styled from "@yb/styled-px2rem";

interface Props extends InputSProps {
	htmlFor: string;
	children: ReactNode;
	read?: boolean;
}

const Wrap = styled.div<{read?: boolean}>`
	display: flex;
	line-height: 1;

	label {
		display: flex;
		gap: 10px;
		align-items: center;
		line-height: 1;
		cursor: pointer;

		&:has(input[type="radio"]:disabled) {
			cursor: initial;
		}
	}

	input[type="radio"] {
		position: relative;
		flex: 0 0 auto;
		width: 24px;
		height: 24px;
		padding-right: 0;
		border-radius: 100%;

		&:before {
			position: absolute;
			top: 50%;
			left: 50%;
			width: 0;
			height: 0;
			border-radius: 50%;
			transform: translate(-50%, -50%);
			content: "";
			cursor: pointer;
			transition: all 250ms ease;
			box-sizing: border-box;
		}

		&:focus {
			outline: none;
		}

		&:checked {
			border: 1px solid var(--emp-color);
			&:before {
				width: 10px;
				height: 10px;
				background-color: var(--emp-color);
			}
		}

		&:disabled {
			background-color: var(--disabled-color);
			cursor: initial;

			&:before {
				background-color: var(--gray-color);
				cursor: initial;
			}
		}
	}
`;

const Radio = ({htmlFor, children, read, ...props}: Props) => (
	<Wrap read={read}>
		<label htmlFor={htmlFor}>
			<input type="radio" {...props} />
			{children}
		</label>
	</Wrap>
);

export default Radio;
